import { Pencil } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";
import { ArrangedUseLimitsData } from "../../../models/featureUseLimits/FeatureUseLimitsData";

const MAX_VISIBLE_BADGES = 3;

export interface IIndividualSettingItemProps {
  arrangedUseLimits: ArrangedUseLimitsData;
  onClickEdit: () => void;
}

export const IndividualSettingItem: React.FunctionComponent<
  IIndividualSettingItemProps
> = ({ arrangedUseLimits, onClickEdit }) => {
  const { t: _t } = useTranslation();
  const t = (key: string, options?: Record<string, unknown>) =>
    _t(`functionManagementPage.functionList.item.${key}`, options);
  const tBadge = (name: string) =>
    _t(`functionManagementPage.functionList.badge.${name}`);

  const enabledFeatures = (arrangedUseLimits.use_limits || []).filter(
    (useLimit) => useLimit.can_use
  );

  const visibleFeatures = enabledFeatures.slice(0, MAX_VISIBLE_BADGES);
  const overflowFeatures = enabledFeatures.slice(MAX_VISIBLE_BADGES);

  const renderActiveFeatures = () => {
    if (enabledFeatures.length === 0) {
      return <span className="no-active-features">{t("no_active_features")}</span>;
    }

    return (
      <>
        {visibleFeatures.map((useLimit) => (
          <span className="feature-badge" key={useLimit.feature.id}>
            {tBadge(useLimit.feature.name)}
          </span>
        ))}
        {overflowFeatures.length > 0 && (
          <span
            className="feature-badge feature-badge-more"
            title={overflowFeatures
              .map((useLimit) => tBadge(useLimit.feature.name))
              .join(", ")}
          >
            {t("more_features", { remaining: overflowFeatures.length })}
          </span>
        )}
      </>
    );
  };

  return (
    <div className="row-td">
      <div className="col-td name">
        <div className="spacing">
          <span className="blue-txt">
            {arrangedUseLimits.email || arrangedUseLimits.name || "-"}
          </span>
        </div>
      </div>
      <div className="col-td active-features">
        <div className="spacing feature-badge-list">{renderActiveFeatures()}</div>
      </div>
      <div className="col-td actions">
        <div className="spacing edit-button">
          <button
            type="button"
            className="btn-icon-edit"
            onClick={onClickEdit}
            aria-label={t("edit")}
            title={t("edit")}
          >
            <Pencil size={18} strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
};
